/* Sequoia Fitness | Website: https://www.sequoia.fitness | Author: Ali Hosseini | Copyright (c) 2026 sequoia.fitness. All rights reserved. */
/* Designed and developed by Pouria Shabani | https://linkedin.com/in/pouriashabani */

import { useEffect, useState } from 'react'
import { OFFICE_NOTE } from '../lib/officeHours.js'

export default function CallClosed() {
  const [open, setOpen] = useState(false)

  useEffect(() => {
    const show = () => setOpen(true)
    const key = (e) => {
      if (e.key === 'Escape') setOpen(false)
    }
    window.addEventListener('seq-call-closed', show)
    document.addEventListener('keydown', key)
    return () => {
      window.removeEventListener('seq-call-closed', show)
      document.removeEventListener('keydown', key)
    }
  }, [])

  if (!open) return null

  return (
    <div className="seq-cc" dir="rtl" role="presentation" onClick={() => setOpen(false)}>
      <div className="seq-cc-box" role="dialog" aria-modal="true" onClick={(e) => e.stopPropagation()}>
        <button className="seq-cc-x" type="button" aria-label="بستن" onClick={() => setOpen(false)}>
          ✕
        </button>
        <p className="seq-cc-t">{OFFICE_NOTE}</p>
        <a className="seq-cc-save" href="/sequoia.vcf" download onClick={() => setOpen(false)}>
          ذخیره‌ی سکویا در مخاطبین
        </a>
      </div>
    </div>
  )
}
